import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=ac77b7d6"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=ac77b7d6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac77b7d6')) {
      api.createRecord('ac77b7d6', component.options)
    } else {
      api.reload('ac77b7d6', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=ac77b7d6", function () {
      api.rerender('ac77b7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/file/Index.vue"
export default component.exports